import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    get,
    HasPagingParameters,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

import { CreateUserAccountModel } from "@TKCCP/Types/ApiModels";

export interface CreateUserAccountParameter extends ApiParameter {
    customerNumber: string;
}

export interface GetCreateUserAccountParameter extends ApiParameter {
    customerNumber: string;
}

const validateUsereUrl = "api/v1/tkccpvalidateuser";

export function getCreateUserAccount(parameter: CreateUserAccountParameter): Promise<CreateUserAccountModel> {
    try {
        const getAccountModel = get<CreateUserAccountModel>(`api/v1/tkccpvalidateuser/${parameter.customerNumber}`);
        return getAccountModel;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            // return {
            //     // successful: false,
            //     // errorMessage: error.errorJson.message,
            // };
        }
        throw error;
    }
}

function customAlert(arg0: string) {
    throw new Error("Function not implemented.");
}
